
define('text!templates/components/welcome_message/welcome_messages.html',[],function () { return '<div class="welcome-messages-holder">\n\n</div>';});

